////import cityPicker from "./CityPicker/CityPicker.vue"
////import Vue from "vue";
////new Vue({
////    el: "#cityPicker",
////    components: {
////        "city-picker": cityPicker
////    }
////})
import cityPicker from "./CityPicker/CityPickerNew.vue"
import Vue from "vue";

new Vue({
    el: "#cityPicker",
    components: {
        "city-picker": cityPicker
    }

})


// WEBPACK FOOTER //
// ./Scripts/app/CityPicker.js